module.exports = "https://la-static.prod-my.games/minigames/collection/img/decor.cfdf0346.svg";